import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface SectionHeaderProps {
  eyebrow?: string
  title: string
  description?: ReactNode
  action?: ReactNode
  align?: 'left' | 'center'
  className?: string
}

export function SectionHeader({ eyebrow, title, description, action, align = 'left', className }: SectionHeaderProps) {
  return (
    <div className={cn('section-header', align === 'center' && 'section-header-center', className)}>
      <div className="section-header-copy">
        {eyebrow && <div className="section-label">{eyebrow}</div>}
        <h2 className="section-title">{title}</h2>
        {description && <div className="body-large section-header-description">{description}</div>}
      </div>
      {action && <div className="section-header-action">{action}</div>}
    </div>
  )
}
